// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as SectionHeadingModuleScss from "../styles/common/SectionHeading.module.scss";

var styles = SectionHeadingModuleScss;

function SectionHeading(Props) {
  var title = Props.title;
  var wave_icon = Props.wave_icon;
  return React.createElement("div", {
              className: styles["section-header-wrapper"]
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: wave_icon.path,
                  height: 45.0,
                  width: 45.0,
                  quality: 100.0,
                  alt: wave_icon.alt_text
                }), React.createElement("h2", {
                  className: styles["section-header"]
                }, title), React.createElement(NextImage$PorterinFeature.make, {
                  src: wave_icon.path,
                  height: 45.0,
                  width: 45.0,
                  quality: 100.0,
                  alt: wave_icon.alt_text
                }));
}

var make = SectionHeading;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
